jQuery(document).ready(function() {

    jQuery('a').each(function() {
    	let aLink = jQuery(this).attr('target');
    	let aTxt = jQuery(this).text();
    	if (aLink == "_blank" || aLink == "blank") {
    		jQuery(this).attr('aria-label', `link to ${aTxt},opens in new window`);
    	}
    });

    let aImg = document.getElementsByTagName("img");
	for (e = 0; e < aImg.length; e++) {
		var r = aImg[e].hasAttribute("alt");
		if (0 == r && aImg[e].setAttribute("alt", "image"), 1 == r) "" == aImg[e].getAttribute("alt") && aImg[e].setAttribute("alt", "image")
	}

    jQuery('a[href="/cart"]').click(function(e) {
        if(jQuery('div#CartDrawer').hasClass('drawer--is-open')){
          e.preventDefault();
          jQuery('button.drawer__close-button').focus();
          jQuery('p.cartTxt').remove();
          jQuery('main').prepend('<p role="alert" class="sr-only cartTxt">Cart Drawer is open</p>');
        } 
      });
  
    jQuery('button.drawer__close-button').click(function(e) {
        setTimeout(function(){ 
          e.preventDefault();
          jQuery('a[href="/cart"]').focus();
          
        }, 100);
    });
  
    setTimeout(function(){
      jQuery('a.hero__slide-link').append('<span class="sr-only">link</span>');
      jQuery('a.jdgm-random-link').append('<span class="sr-only">link</span>');

      jQuery('div#Linklist-2').removeAttr('aria-labelledby');
      jQuery('div#Sublinklist-2-3').removeAttr('aria-labelledby');

      jQuery('.slick-slide').each(function() {
        let attrb = jQuery(this).attr('aria-describedby');

        if (typeof attrb !== 'undefined' && attrb !== false) {
              jQuery(this).prepend(`<span class="sr-only" id=${attrb}>slide</span>`);
        }
        
      });
      
    }, 2000);

    jQuery('label[for="jdgm_reviewer_name"]').each(function(index) {
        jQuery(this).removeAttr('for').attr('for',`${index}revName`);
    });

    jQuery('input#jdgm_reviewer_name').each(function(index) {
        jQuery(this).removeAttr('id').attr('id',`${index}revName`);
    });

    jQuery('label[for="jdgm_reviewer_email"]').each(function(index) {
        jQuery(this).removeAttr('for').attr('for',`${index}revEmail`);
    });

    jQuery('input#jdgm_reviewer_email').each(function(index) {
        jQuery(this).removeAttr('id').attr('id',`${index}revEmail`);
    });

    jQuery('label[for="jdgm_review_title"]').each(function(index) {
        jQuery(this).removeAttr('for').attr('for',`${index}revTitle`);
    });

    jQuery('input#jdgm_review_title').each(function(index) {
        jQuery(this).removeAttr('id').attr('id',`${index}revTitle`);
    });

    jQuery('label[for="jdgm_review_body"]').each(function(index) {
        jQuery(this).removeAttr('for').attr('for',`${index}revBody`);
    });

    jQuery('textarea#jdgm_review_body').each(function(index) {
        jQuery(this).removeAttr('id').attr('id',`${index}revBody`);
    });  
 
   jQuery('button.collapsible-trigger span.collapsible-trigger__icon--open').append('<span class="sr-only">link</span>');
   (function() {
        var origin,target;
    	var debounce = (function(callback) {
    		var timeout;
    		return function() {
    			if (timeout) clearTimeout(timeout);
    			timeout = setTimeout(callback, 200);
    		}
    	})(function callback() {
            origin = document.getElementById('mps-sales-notification');
			origin && (target = origin.querySelector('.sn-img > a'));
    		try {
    			if (target && target.childNodes.length == 0) {
    				jQuery(target).append('<span class="sr-only">link</span>');
    			}
                
    		} catch (e) {
    			console.warn('error', e);
    		}
    	});
    	debounce();
    	var observer = new MutationObserver(debounce);
    	observer.observe(document.body, {
    		childList: true,
    		subtree: true
    	});
    })();
});